export default "__VITE_ASSET__5aXqOeXY__"